import { application } from "./application"

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import LangSwitcherController from "./lang_switcher_controller"
application.register("lang-switcher", LangSwitcherController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
